import createAction from '../../common/services/create-action';

export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const HIDE_GLOBAL_LOADER = 'HIDE_GLOBAL_LOADER';

export const showGlobalLoader = createAction(SHOW_GLOBAL_LOADER);
export const hideGlobalLoader = createAction(HIDE_GLOBAL_LOADER);
